import React, { useCallback } from 'react';
import type { QnAStateType } from '@uber/react-qna-lib';
import { styled } from 'baseui';
import { Pagination, SIZE } from 'baseui/pagination';
import { HeadingXSmall } from 'baseui/typography';
import type { AnswerT } from '../types/types';
import Questionnaire from './questionnaire';
type PropsT = {
  currentPage: number;
  totalPages: number;
  handlePageChange: (nextPage: number) => void;
  currentQuestionnaire: {
    questionnaire: QnAStateType;
    name: string;
  };
  updateQuestionnaire: (updatedQuestionnaire: {
    questionnaire: QnAStateType;
    name: string;
  }) => void;
  showHeading: boolean;
  showValidationErrors?: boolean;
  mode?: 'compact' | 'default';
  isQuestionnaireComposable?: boolean;
};
const Container = styled<'div', {
  $isCompactMode: boolean;
}>('div', ({
  $theme,
  $isCompactMode
}) => ({
  ...($isCompactMode ? {} : $theme.borders.border200),
  display: 'flex',
  flexDirection: 'column',
  borderTop: 'none',
  borderBottom: 'none',
  overflow: 'auto',
  height: $isCompactMode ? `calc(100% - 40px)` : '100%',
  width: '100%'
}));
const QuestionnairePanelContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: $theme.sizing.scale500
}));
const PaginationContainer = styled<'div', {
  $isCompactMode: boolean;
}>('div', ({
  $theme,
  $isCompactMode
}) => ({
  marginTop: 'auto',
  backgroundColor: $theme.colors.backgroundPrimary,
  padding: $isCompactMode ? 0 : $theme.sizing.scale400,
  display: 'flex',
  justifyContent: 'center'
}));
const headingOverride = (isCompatMode: boolean) => ({
  Block: {
    style: ({
      $theme
    }) => ({
      marginTop: isCompatMode ? '0' : $theme.sizing.scale300,
      marginBottom: $theme.sizing.scale300
    })
  }
});
export const QuestionnairePanel = ({
  currentPage,
  totalPages,
  handlePageChange,
  currentQuestionnaire,
  updateQuestionnaire,
  showHeading,
  showValidationErrors,
  mode = 'default',
  isQuestionnaireComposable
}: PropsT) => {
  const isCompatMode = mode === 'compact';
  const handleOnQuestionnaireChange = useCallback((isAnswerValid?: boolean, updatedAnswers?: AnswerT) => {
    if (updatedAnswers) {
      const updatedQuestionnaire = {
        questionnaire: {
          ...currentQuestionnaire.questionnaire,
          answers: updatedAnswers
        },
        name: currentQuestionnaire.name
      };
      updateQuestionnaire(updatedQuestionnaire);
    }
  }, [currentQuestionnaire, updateQuestionnaire]);
  return <Container $isCompactMode={isCompatMode}>
      <QuestionnairePanelContainer>
        {showHeading && !isCompatMode && <>
            <HeadingXSmall overrides={headingOverride(isCompatMode)}>Questionnaire</HeadingXSmall>
          </>}
        <Questionnaire key={currentPage} questionnaire={currentQuestionnaire.questionnaire} onChange={handleOnQuestionnaireChange} isQuestionnaireComposable={isQuestionnaireComposable} {...showValidationErrors ? {
        showValidationErrors: true
      } : {}} />
      </QuestionnairePanelContainer>
      {totalPages > 1 && <PaginationContainer $isCompactMode={isCompatMode}>
          <Pagination numPages={totalPages} currentPage={currentPage} size={SIZE.mini} onPageChange={({
        nextPage
      }) => {
        handlePageChange(Math.min(Math.max(nextPage, 1), totalPages));
      }} />
        </PaginationContainer>}
    </Container>;
};
export default QuestionnairePanel;